"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInquiryByIdExtraReducers = void 0;
const tslib_1 = require("tslib");
const services_1 = tslib_1.__importDefault(require("../../../../services"));
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const utils_1 = require("../../../../utils");
const Inquiry_1 = tslib_1.__importDefault(require("../__model__/Inquiry"));
const getIncludesParams_1 = require("../../../../shared/getIncludesParams");
const getInquiryById = toolkitRaw.createAsyncThunk('inquiries/get-inquiry-by-id', async (data, { rejectWithValue }) => {
    var _a, _b;
    const { inquiryInternalId } = data;
    try {
        const response = await services_1.default.get(`/api/saas/me/inquiries/${inquiryInternalId}`, {
            ...((_b = (_a = data === null || data === void 0 ? void 0 : data.setting) === null || _a === void 0 ? void 0 : _a.httpRequestConfig) !== null && _b !== void 0 ? _b : {}),
            params: {
                includes: (0, getIncludesParams_1.getDefaultIncludesParams)('saas_inquiries'),
            },
        });
        const payload = (0, utils_1.deserialize)(response.data);
        const InquiryImplementation = new Inquiry_1.default(payload);
        return InquiryImplementation.data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getInquiryByIdExtraReducers = (builder) => {
    builder.addCase(getInquiryById.pending, (state) => {
        state.inquiry.loading = true;
    });
    builder.addCase(getInquiryById.fulfilled, (state, action) => {
        state.inquiry.data = action.payload;
        state.inquiry.loading = false;
        state.inquiry.error = false;
    });
    builder.addCase(getInquiryById.rejected, (state) => {
        state.inquiry.loading = false;
        state.inquiry.error = true;
    });
};
exports.getInquiryByIdExtraReducers = getInquiryByIdExtraReducers;
exports.default = getInquiryById;
//# sourceMappingURL=index.js.map